var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 1",
    d: "M18 11L0 22V0z"
  })));
}

export default __webpack_public_path__ + "1f2d20c34c0b34cb8ec1f87b1a8dd472.svg";
export { SvgPlay as ReactComponent };